import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';
import servicioParametros from '../servicios/ServicioParametros';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
export class Parametros extends Component {
    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 20
            },
            inicio: 0,
            parametros:{},
            errores:{},
            mostrarModalParametros:false,
            erroresRequeridos:{}
            
        }

    }
    componentDidMount() {
     this.obtenerPagina();
 
     }

     cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
     obtenerPagina() {
        let { paginacion } = this.state;
        servicioParametros.paginacion(paginacion).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });
            

        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

    }
    preeditar = (objeto, rowdata) => {
       
      }
    
      onBorrar = (fila, datos) => {
       
      }

      guardar = () => {
        let { parametros } = this.state;
        const validacion = this.validarFormulario(parametros);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
        servicioParametros.guardar(parametros).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false)
                this.setState({ parametros: {},mostrarModalParametros:false});
                this.componentDidMount();

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
       
      }}
      actualizar = () => {
        let { parametros } = this.state;
        const validacion = this.validarFormulario(parametros);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
        servicioParametros.actualizar(parametros).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false)
                this.setState({ parametros: {},mostrarModalParametros:false});
                this.componentDidMount();

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }
      }
      asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    
      }
      editarParametro = (rowData, column) => {

        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit" className="p-button-success" name="xml"
                    tooltip="editar" onClick={(e) => this.editar(column.rowData)} >
                </Button>
            </div>
        </div>;
    }
    validarFormulario = (parametro) => {
        const errores = {};
        if(!parametro.nombre)
        errores.nombre = "El correo es requerido";
        if(!parametro.descripcion)
        errores.descripcion = "La descripcion es requerida";
        if(!parametro.valor)
        errores.valor ="El valor es requerido";

return errores;
    }
    
    editar(objeto) {
        this.setState({ mostrarModalParametros: true, parametros: objeto });
    }
    
    render() {
        const { parametros, paginacion,inicio,erroresRequeridos } = this.state;
        const dialogFooter = (
            <div>
                <Button icon="pi-md-check" onClick={this.actualizar} label="Guardar" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ parametro: {}, mostrarModalParametros: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );
        return (<div className="card card-w-title">
            <Growl ref={(el) => this.growl = el} />
            <h1>Administración de Parámetros</h1>
            <h4>Los campos con (*) son obligatorios</h4>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    <h4>*Nombre:</h4>
                    <InputText id="nombre" name="parametros.nombre" value={parametros.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
                    {erroresRequeridos.nombre ? <div><br /> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
                </div>
                <div className="p-col-12 p-md-4">
                    <h4>*Valor:</h4>
                    <InputText id="valor" name="parametros.valor" value={parametros.valor || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.valor ? 'p-error' : ''} />
                    {erroresRequeridos.valor ? <div><br /> <Message severity="error" text={erroresRequeridos.valor} /> </div> : null}
                </div>
                <div className="p-col-12 p-md-4">
                    <h4>*Descripción:</h4>
                    <InputText id="descripcion" name="parametros.descripcion" value={parametros.descripcion || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.descripcion ? 'p-error' : ''} />
                    {erroresRequeridos.descripcion ? <div><br /> <Message severity="error" text={erroresRequeridos.descripcion} /> </div> : null}
                </div>

            </div>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4 p-offset-8">
                    <br />
                    <Button label="Guardar" className="p-button-rounded p-button-warning" onClick={this.guardar} />
                </div>
            </div>
            <Card>
                <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} scrollHeight="220px"  >
                    <Column field="nombre" header="Nombre" style={{ width: '200px' }} filter={false} autoLayout={true} />
                    <Column field="valor" header="Valor" style={{ width: '200px' }} filter={false} autoLayout={true} />
                    <Column field="descripcion" header="Descripción" style={{ width: '110px' }} />
                    <Column header="Editar" body={this.editarParametro.bind(this)} style={{ width: '100px' }} />
                </DataTable>
                <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={inicio} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
            </Card>
            <Dialog header="Parametros, los campos con * son requeridos." blockScroll visible={this.state.mostrarModalParametros} modal={true} footer={dialogFooter} style={{ width: '60vw' }} onHide={() => this.setState({ parametros: {}, mostrarModalParametros: false, erroresRequeridos: {} })}>
            <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="nombre">* Nombre:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="nombre" name="parametros.nombre" value={parametros.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
                        {erroresRequeridos.nombre ? <div> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-2">
                        <label htmlFor="valor">* Valor:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="valor" name="parametros.valor" value={parametros.valor || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.valor ? 'p-error' : ''} />
                        {erroresRequeridos.valor ? <div> <Message severity="error" text={erroresRequeridos.valor} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="valor">* Descripcion:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="descripcion" name="parametros.descripcion" value={parametros.descripcion || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.descripcion ? 'p-error' : ''} />
                        {erroresRequeridos.descripcion ? <div> <Message severity="error" text={erroresRequeridos.descripcion} /> </div> : null}
                    </div>
                    </div>
            </Dialog>
        </div>
        );
    }
}